import { uniq } from "lodash";
import { ContactOption } from "../api/firebase/types/scenario.types";

const addContactsToSettings = (
  contactIdsToAdd: string[],
  contactSettings: Map<ContactOption, string[]>
) => {
  const allContactIds = contactSettings.get(ContactOption.ALL) || [];
  contactSettings.set(ContactOption.ALL, [
    ...allContactIds,
    ...contactIdsToAdd,
  ]);
  return contactSettings;
};

const removeContactsFromSettings = (
  contactIdsToRemove: string[],
  contactSettings: Map<ContactOption, string[]>
) => {
  contactSettings.forEach((value, key, map) =>
    map.set(
      key,
      value.filter((id) => !contactIdsToRemove.includes(id))
    )
  );
  return contactSettings;
};

const getAllUniqueIds = (contactSettings?: Map<ContactOption, string[]>) => {
  if (!contactSettings) return [];
  return uniq(Array.from(contactSettings.values()).flat());
};

const processIncomingIds = (
  incomingIds: string[],
  contactSettings?: Map<ContactOption, string[]>
) => {
  const uniqueSettingsIds = getAllUniqueIds(contactSettings);
  const newContactSettings = new Map(contactSettings);

  const newIds = incomingIds.filter((id) => !uniqueSettingsIds.includes(id));
  const idsToRemove = uniqueSettingsIds.filter(
    (id) => !incomingIds.includes(id)
  );
  addContactsToSettings(newIds, newContactSettings);
  removeContactsFromSettings(idsToRemove, newContactSettings);

  return newContactSettings;
};

const ContactService = {
  addContactsToSettings,
  removeContactsFromSettings,
  getAllUniqueIds,
  processIncomingIds,
};

export default ContactService;
